<template>
  <div>
    <div class="row">
      <div v-if="!printOnSite && physicalEnabled" class="col-12 col-md-6 col-lg-4">
        <b-card title="Post">
          <b-card-text>Manage and search for post</b-card-text>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="navigateToSearchPage({
              deliveryStatus: '',
              postType: 'Physical',
            })"
          >
            All Post
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="navigateToSearchPage({
              deliveryStatus: 'sentForPrinting',
              postType: 'Physical',
            })"
          >
            Being printed
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="navigateToSearchPage({
              deliveryStatus: 'dispatched',
              postType: 'Physical',
            })"
          >
            Dispatched
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="navigateToSearchPage({
              deliveryStatus: 'delivered',
              postType: 'Physical',
            })"
          >
            Delivered
          </b-btn>
        </b-card>
      </div>

      <div v-if="printOnSite && physicalEnabled" class="col-12 col-md-6 col-lg-4">
        <b-card title="Post (print on site)">
          <b-card-text>Manage and search for physical post</b-card-text>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="navigateToSearchPage({
              status: 'AwaitingConfirmation',
              sentForPrinting: false,
              dispatched: false,
              delivered: false,
              printOnSite: true,
            })"
          >
            Awaiting Confirmation
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="navigateToSearchPage({
              status: 'Approved',
              sentForPrinting: false,
              dispatched: false,
              delivered: false,
              printOnSite: true,
            })"
          >
            Ready for print
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="navigateToSearchPage({
              status: 'Approved',
              sentForPrinting: true,
              printOnSite: true,
              delivered: true
            })"
          >
            Printed
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="navigateToSearchPage({
              status: 'Rejected',
              sentForPrinting: false,
              printOnSite: true,
              delivered: false
            })"
          >
            Rejected Post
          </b-btn>
        </b-card>
      </div>

      <div v-if="repliesEnabled && physicalEnabled" class="col-12 col-md-6 col-lg-4">
        <b-card title="Post replies">
          <b-card-text>Scan & upload replies</b-card-text>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({name: 'post-reply-search'})"
          >
            Search Replies
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({name: 'post-replies'})"
          >
            Upload Replies
          </b-btn>
          <b-btn
            class="full-width btn-primary"
            variant="primary"
            @click="$router.push({name: 'post-replies-fail'})"
          >
            Failed Replies
          </b-btn>
        </b-card>
      </div>
    </div>

    <div class="row">
      <div v-if="digitalEnabled" class="col-12 col-md-6 col-lg-4">
        <b-card title="Digital post">
          <b-card-text>Manage and search for digital post</b-card-text>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="navigateToSearchPage(
              { status: '',printOnSite: printOnSite },
              true,
            )"
          >
            All Post
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="navigateToSearchPage(
              { status: 'AwaitingConfirmation', printOnSite: printOnSite },
              true
            )"
          >
            Post Needing Approval
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="navigateToSearchPage(
              { status: 'Approved', printOnSite: printOnSite },
              true,
            )"
          >
            Approved Post
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="navigateToSearchPage(
              { status: 'Rejected', printOnSite: printOnSite },
              true,
            )"
          >
            Rejected Post
          </b-btn>
        </b-card>
      </div>

      <div v-if="digitalEnabled" class="col-12 col-md-6 col-lg-4">
        <b-card title="Digital replies">
          <b-card-text>Manage and search for digital replies</b-card-text>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="navigateToDigitalRepliesPage({ status: ''})"
          >
            All Replies
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="navigateToDigitalRepliesPage({ status: 'AwaitingConfirmation'})"
          >
            Replies Needing Approval
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="navigateToDigitalRepliesPage({ status: 'Approved'})"
          >
            Approved Replies
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="navigateToDigitalRepliesPage({ status: 'Rejected'})"
          >
            Rejected Replies
          </b-btn>
        </b-card>
      </div>
    </div>

    <div class="row align-items-end">
      <div class="col-12 col-md-6 col-lg-4">
        <b-card title="Keywords & phrases management">
          <b-card-text>Search for, create, update and remove keywords that flag up in post</b-card-text>
          <b-btn
            class="full-width"
            variant="primary"
            :to="{name: 'keyword-search'}"
          >
            Manage Keywords
          </b-btn>
        </b-card>
      </div>

      <div class="col-12 col-md-6 col-lg-4">
        <b-card title="Ban list">
          <b-card-text>Search for a sender who has been banned and remove any bans if needed</b-card-text>
          <b-card-text>
            <b-btn
              class="full-width"
              variant="primary" :to="{name: 'bans'}"
            >
              Ban Search
            </b-btn>
          </b-card-text>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Dashboard',
  components: {},
  computed: {
    ...mapState({
      digitalEnabled: state => state.auth.user.prison.purple_post_digital_enabled,
      physicalEnabled: state => state.auth.user.prison.purple_post_physical_enabled,
      printOnSite: state => state.auth.user.prison.purple_post_print_on_site,
      filters: state => state.postCard.filters,
      filtersDigitalReplies: state => state.digitalReplies.filters,
      repliesEnabled: state => state.auth.user.prison.purple_post_onsite_replies_enabled,
    }),
  },
  methods: {
    navigateToSearchPage(filters, digitalPost = false) {
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const filtersKey in filters) {
        this.updateFilter(filtersKey, filters[filtersKey]);
      }
      this.updateFilter('postType', digitalPost ? 'Digital' : 'Physical');

      this.$store.commit('postCard/SET_DEFAULT_FILTERS', { ...this.filters }); // set new default filters
      this.$router.push({ name: 'post-search' });
    },
    updateFilter(filterName, e) {
      this.$store.commit('postCard/SET_FILTER_ITEM', { name: filterName, value: e });
    },
    navigateToDigitalRepliesPage(filters) {
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const filtersKey in filters) {
        this.updateFilterDigitalReply(filtersKey, filters[filtersKey]);
      }

      this.$store.commit('digitalReplies/SET_DEFAULT_FILTERS', { ...this.filtersDigitalReplies }); // set new default filters
      this.$router.push({ name: 'digital-replies' });
    },
    updateFilterDigitalReply(filterName, e) {
      this.$store.commit('digitalReplies/SET_FILTER_ITEM', { name: filterName, value: e });
    },
  },
}
</script>

<style>

</style>
